import {mock} from "../../conf/context";

const agreementService = {

    getReleaseOfPersonalInformationAgreement: async () => {
        const response = await mock.get('releaseOfPersonalInformationAgreement');
        return response.data;
    }

}

export default agreementService;